import {
	Box,
	Button,
	IconButton,
	Modal,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tooltip,
	Typography,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import PageHeading from '../../Components/PageHeading';
import DragDropUpload from '../../Components/DragDropUpload';
import { AppColors } from '../../Utils/helper/AppColors';
import { Avatar, Tag } from 'antd';
import {
	AddIcon,
	BsToggleOnIcon,
	DeleteIcon,
	EditIcon,
	PiToggleLeftBoldIcon,
	PiToggleRightBoldIcon,
	ToggleOffIcon,
} from '../../Components/Icons/Icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATH_NAME } from '../../Routes/Pathname';
import CultService from '../../Services/CultService';
import DeleteConfirm from '../../Components/DeleteConfirm';
import toast from 'react-hot-toast';
import { HelperTexts } from '../../Utils/helper/HelperTexts';
import PageLoader from '../../Components/PageLoader';
import DepartmentTag from '../../Components/DepartmentTag';
import SearchBar from '../../Components/SearchBar';
import { filterBySearch, getColorSettings } from '../../Utils/helper/commonUtils';
import { useSelector } from 'react-redux';
import UserThumbnail from '../../Components/User/UserThumbnail';
import CustomTablePagination from '../../Components/CustomTablePagination';
import { debounce, replace } from 'lodash';
import EmployeesEmptyView from './Components/EmployeesEmptyView';
import CustomTag from '../../Components/CustomTag';
import AddEditEmployee from './AddEditEmployee';
import dayjs from 'dayjs';
import DataNotFound from '../../Components/DataNotFound';

export default function EmployeesList() {
	const [list, setList] = useState([]);
	const navigate = useNavigate();
	const { state } = useLocation();
	const [deleteModal, setDeleteModal] = useState(null);
	const [activeModal, setActiveModel] = useState(null);
	const [importModal, setImportModal] = useState(false);
	const [deleting, setDeleting] = useState(false); // we can chage its name as well
	// const [active, setActivating] = useState(false);
	const [loading, setLoading] = useState(false);
	const [search, setSearch] = useState('');
	const [previousSearch, setPreviousSearch] = useState('');
	const fileRef = useRef();
	const [openAddEditModal, setOpenAddEditModal] = useState(false);
	const [editEmployee, setEditEmployee] = useState(null); // for edit mode
	const [pagination, setPagination] = useState({ count: 0, rowsPerPage: 10, page: 1 });
	const company = useSelector((state) => state?.app?.company);
	const [activeUsers,setActiveUsers] = useState(0);

	const NO_DATA = false;

	const getList = async (page = 1, limit = pagination?.rowsPerPage, searchTerm = search || '') => {
		setLoading(true);
		try {
			let res = await CultService.getAllUsersPaginated({
				params: {
					page: page,
					limit,
					companyId: company?._id,
					filterQuery: { search: [searchTerm.slice(0, 100)] },
				},
			});
			console.log('res - ', res);
			if (res.status == 200) {
				if (res?.data?.pagination) {
					const { totalUsers, currentPage, totalPages, pageSize } = res?.data?.pagination;
					setPagination({
						count: totalUsers,
						rowsPerPage: pageSize,
						totalPages: totalPages,
						page: currentPage,
					});
					setActiveUsers(res?.data?.activeUsersCount || 0);
					setList(res.data?.users);
				}
			}

			// let res = await Promise.race([CultService.getEmployeesList({ params: { companyId: company?._id } })]);
			// if (res.status) {
			// 	setList(res.data);
			// }
		} catch (err) {
			toast.error(HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
			if (state) navigate(PATH_NAME.EMPLOYEES_LIST, { replace: true });
		}
	};

	const handleDelete = async () => {
		setDeleting(true);
		try {
			let res = await CultService.deleteUser({ params: { id: deleteModal } });
			if (res?.status == 200) {
				setDeleteModal(false);
				getList();
				// res?.status && toast.error(res?.message);
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setDeleting(false);
		}
	};

	const handleChangeStatus = async () => {
		setDeleting(true);
		try {
			let res = await CultService.changeUserStatus({ params: { id: activeModal?.id }, data: { isActive: !activeModal?.status } });
			if (res?.status == 200) {
				// setActiveModel(false);
				getList(pagination?.page, pagination?.rowsPerPage, search);
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setActiveModel(false);
			setDeleting(false);
		}
	};

	const debouncegetList = debounce((searchTerm, paginationData) => {
		// will run only if the search term is changed
		if (!paginationData) {
			getList();
			return;
		}

		// const newPage = 1;
		// const newRowsPerPage = 10;

		// setPagination((prev) => ({ ...prev, page: newPage, rowsPerPage: newRowsPerPage }));
		// getList(newPage, newRowsPerPage);

		// will run if some state data is coming from useLocation...
		getList(paginationData?.page || 1, paginationData?.rowsPerPage || 10, searchTerm);
	}, 1000);

	// only run when we change search term from search bar
	useEffect(() => {
		if (state) return;

		if (company) debouncegetList(search, null);

		return () => debouncegetList.cancel();
	}, [company, search]);

	// only run when we have state data coming from useLocation
	useEffect(() => {
		if (company && state) {
			setSearch(state?.employeeListPageData?.search);
			debouncegetList(state?.employeeListPageData?.search, state?.employeeListPageData?.pagination);
		}

		return () => debouncegetList.cancel();
	}, [company, state]);

	// useEffect(() => {

	// 	if (state) {
	// 		console.log('stateLL - ', state);
	// 		// setPagination(state?.employeeListPageData?.pagination);
	// 		// setSearch(state?.employeeListPageData?.search);
	// 		navigate(PATH_NAME.EMPLOYEES_LIST, { replace: true });
	// 	}
	// }, [state, company]);
	// useEffect(() => {
	// 	if (company && !state) {
	// 		console.log('1');
	// 		 getList();
	// 	}

	// }, [company]);

	const handleImport = async (e) => {
		console.log('in');
		console.log(fileRef);
		const file = e.target.files[0];

		console.log('file - ', file);

		if (!file) return;

		const allowedTypes = [
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
			'application/vnd.ms-excel', // .xls
			'text/csv', // .csv
		];

		if (!allowedTypes.includes(file.type)) {
			toast.error('Please upload a valid file: CSV, XLSX, or XLS.');
			fileRef.current = null;
			return;
		}

		try {
			const formData = new FormData();
			formData.append('file', file);
			formData.append('companyId', company?._id);

			const res = await CultService.importUserExcel({
				data: formData,
				config: {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				},
			});

			if (res.status === 200) {
				setImportModal(false);
				getList();
 				toast.success(`${res?.data?.savedUsers?.length || 0} users added, ${res?.data?.updatedUsers?.length || 0} users updated successfully.`);
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			fileRef.current = null;
		}
	};

	    const localSettingColors = getColorSettings();


	return (
		<Stack sx={{ padding: 2 }} gap={3}>
			<PageHeading title="Employees" subTitle="Manage your team members and their account permissions here." renderRight={
				<Stack direction="row" gap={2} alignItems="center">
					<Typography variant='subtitle1' color={localSettingColors.fontColor}>
						Total : {pagination?.count || 0}
					</Typography>
					<Typography variant='subtitle1' color={localSettingColors.fontColor}>
						Active : {activeUsers}
					</Typography>
				</Stack>

			} />

			{NO_DATA ? (
				<Box
					sx={{
						height: 'calc(100vh - 90px)',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						backgroundColor: AppColors.WHITE,
						borderRadius: '15px',
					}}
				>
					<EmployeesEmptyView handleImport={handleImport} noBorderIcon={true} />
				</Box>
			) : (
				<>
					{/* <DragDropUpload
						fileRef={fileRef}
						subText="CSV, XSLS or XLS (max. 50 mb)"
						sampleFile="sample_user.xlsx"
						onUpload={handleImport}
						extra="While entering the details in excel file, please ensure that the phone numbers are added with the clountry code and time zone to be picked from the list of time zone mentioned in the excel sheet."
					/> */}
					<Stack direction="row" gap={2} alignItems="center">
						<SearchBar width="702px" search={search} color={localSettingColors.fontColor} bgColor={localSettingColors.quinary} setSearch={setSearch} />

						<Stack ml={'auto'}></Stack>
						{/* <Button
							onClick={() => navigate(PATH_NAME.EMPLOYEE_ADD)}
							startIcon={<AddIcon color={AppColors.WHITE} />}
							variant="contained"
						>
							Add Employee
						</Button> */}
						<Button
							onClick={() => {
								setEditEmployee(null); // clear edit data
								setOpenAddEditModal(true);
							}}
							startIcon={<AddIcon color={AppColors.WHITE} />}
							variant="contained"
							color="info"
						>
							Add Employee
						</Button>

						<Button onClick={() => setImportModal(true)} variant="contained" color="info">
							Upload File
						</Button>
					</Stack>

					<TableContainer sx={{ height: 'calc(100vh - 200px)', backgroundColor: AppColors.WHITE }}>
						{list?.length === 0 ? (
							<DataNotFound />
						) : (
							<Table stickyHeader>
								<TableHead>
									<TableRow
										sx={{
											position: 'sticky',
											top: 0,
											backgroundColor: 'background.paper',
											zIndex: 3,
										}}
									>
										{/* <TableCell colSpan={12}>
										<Stack direction="row" alignItems="flex-start" justifyContent="space-between">
											<Stack>
												<Stack direction="row" alignItems="center" gap={1}>
													<Typography variant="body1">Team Members</Typography>
													<Tag style={{ borderRadius: 50 }} color="purple">
														{list?.length} Users
													</Tag>
												</Stack>
												<Typography variant="subtitle2">Manage your team members and their account permissions here.</Typography>
											</Stack>
										</Stack>
									</TableCell> */}
									</TableRow>
								</TableHead>

								<TableHead
									sx={{
										'& .MuiTableCell-root': {
											fontSize: 14,
											lineHeight: '150%',
											letterSpacing: '0%',
											fontFamily: 'Poppins',
											color: AppColors.HEADING_TITLE2,
											fontWeight: 600,
											paddingTop: '16px',
											paddingBottom: '20px',
										},
									}}
								>
									<TableRow>
										<TableCell>Name</TableCell>
										<TableCell>Source</TableCell>
										<TableCell>Email address</TableCell>
										<TableCell>Phone No.</TableCell>
										<TableCell>Department</TableCell>
										<TableCell>Date of Joining</TableCell>
										<TableCell>Date of Relieving</TableCell>
										<TableCell>Timezone</TableCell>
										<TableCell>Actions</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{/* filterBySearch(list, search, ['email', 'phoneNumber', 'department']) */}
									{list?.map((c, index) => (
										<TableRow
										sx={{
										'& .MuiTableCell-root': {
											
											paddingTop: '10px',
											paddingBottom: '10px',
										},
									}}
										key={index}>
											<TableCell>
												<UserThumbnail noPagination={true} userId={c?._id} user={c} />
											</TableCell>

											<TableCell>
												<Stack direction="row" flexWrap="wrap">
													{c?.source && <CustomTag tagTitle={c?.source} fontSize={14} fontWeight={400} lineHeight={'150%'} />}
												</Stack>
											</TableCell>

											<TableCell>
												<Typography variant="subtitle2">{c?.email}</Typography>
											</TableCell>
											<TableCell>
												<Typography variant="subtitle2">{c?.phoneNumber}</Typography>
											</TableCell>
											<TableCell>
												<Stack direction="row" gap={1} flexWrap="wrap">
													{c?.department && (
														<CustomTag tagTitle={c?.department} fontSize={14} fontWeight={400} lineHeight={'150%'} />
													)}
												</Stack>
											</TableCell>

											<TableCell>
												<Typography variant="subtitle2">
													{c?.dateOfJoining ? dayjs(c?.dateOfJoining).format('DD-MM-YYYY') : ''}
												</Typography>
											</TableCell>

											<TableCell>
												<Typography variant="subtitle2">
													{c?.dateOfRelieving ? dayjs(c?.dateOfRelieving).format('DD-MM-YYYY') : ''}
												</Typography>
											</TableCell>

											<TableCell>
												<Typography variant="subtitle2">{c?.timezone}</Typography>
											</TableCell>
											<TableCell>
												<Stack direction="row" alignItems="center" gap={1}>
													{/* {c?.type !== "admin" ? <IconButton onClick={() => setDeleteModal(c._id)} size="small">
											<DeleteIcon />
										</IconButton> : null} */}
													<Tooltip
														slotProps={{
															tooltip: {
																sx: {
																	// bgcolor: '#ECE7FC',
																	// color: '#683FC7',
																	boxShadow: '0 0 4 0 #B9B9F780',
																	radius: '5px',
																	// border: `1px solid ${theme.palette.primary.lightest_shade}`,
																},
															},
															
														}}
														arrow
														title="Edit"
													>
														{/* <IconButton
														onClick={() => {
															navigate(PATH_NAME.EMPLOYEE_EDIT, {
																state: { user: c, employeeListPageData: { search, pagination } },
															});
														}}
														size="small"
													>
														<EditIcon color={localSettingColors.fontColor} />
													</IconButton> */}

														<IconButton
															onClick={() => {
																setEditEmployee(c);
																setOpenAddEditModal(true);
															}}
															size="small"
														>
															<EditIcon color={localSettingColors.fontColor} size={20} />
														</IconButton>
													</Tooltip>

													

													{c?.type !== 'admin' && (
														<Tooltip
															slotProps={{
																tooltip: {
																	sx: {
																		// bgcolor: '#ECE7FC',
																		// color: '#683FC7',
																		boxShadow: '0 0 4 0 #B9B9F780',
																		radius: '5px',
																		// border: `1px solid ${theme.palette.primary.lightest_shade}`,
																	},
																},
																
															}}
															arrow
															title={!c?.isActive ? 'Deactivate' : 'Activate'}
														>
															<IconButton onClick={() => setActiveModel({ id: c._id, status: c?.isActive })} size="small">
																{c?.isActive ? (
																	<BsToggleOnIcon color={localSettingColors.fontColor} size={24} />
																) : (
																	<ToggleOffIcon color={localSettingColors.fontColor} size={24} />
																)}
															</IconButton>
														</Tooltip>
													)}
												</Stack>
											</TableCell>
										</TableRow>
									))}
									<TableRow
										sx={{
											position: 'sticky',
											bottom: 0,
											backgroundColor: '#fff',
											zIndex: 2,
										}}
									>
										<TableCell sx={{ paddingY: '4px' }} colSpan={12} align="center">
											<CustomTablePagination
												{...pagination}
												onChange={(p, r) => getList(p, r)}
												onRowsPerPageChange={(e) => getList(1, e.target.value)}
											/>
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						)}
					</TableContainer>
				</>
			)}

			<DeleteConfirm
				open={Boolean(deleteModal)}
				onClose={() => setDeleteModal(false)}
				onDelete={handleDelete}
				loading={deleting}
				title="Delete User?"
				subTitle="Are you sure you want to delete this user?"
			/>

			<DeleteConfirm
				open={Boolean(activeModal)}
				onClose={() => setActiveModel(false)}
				onDelete={handleChangeStatus}
				loading={deleting}
				title={activeModal?.status ? 'Inactive User?' : 'Active User?'}
				subTitle={`Are you sure you want to ${activeModal?.status ? 'Inactive' : 'Active'} this user?`}
			/>

			<Modal open={importModal}>
				<EmployeesEmptyView
					handleImport={handleImport}
					isModel={true}
					noBorderIcon={true}
					onClose={() => setImportModal(false)}
				/>
			</Modal>

			<Modal
				open={openAddEditModal}
				sx={{
					zIndex: 100,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Box sx={{ width: 700, maxWidth: '95vw', bgcolor: '#fff', borderRadius: 2, p: 0, mx: 'auto', my: 'auto' }}>
					<AddEditEmployee
						open={openAddEditModal}
						onClose={() => setOpenAddEditModal(false)}
						user={editEmployee}
						refreshList={getList}
					/>
				</Box>
			</Modal>

			{loading && <PageLoader />}
		</Stack>
	);
}
